export default __webpack_public_path__ + "static/media/mindmap_fonctions_executives.08aa2991.png";